import { render, staticRenderFns } from "./MetricCallout.vue?vue&type=template&id=279299f2&scoped=true"
import script from "./MetricCallout.vue?vue&type=script&lang=ts"
export * from "./MetricCallout.vue?vue&type=script&lang=ts"
import style0 from "./MetricCallout.vue?vue&type=style&index=0&id=279299f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279299f2",
  null
  
)

export default component.exports